import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from 'utils/apiUtils';


import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
  Snackbar
} from '@mui/material';

const ComingSoonPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      // Making a POST request using axios
      const response = await axios.post(`${API_BASE_URL}/api/subscribe`, { email }, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
  
      // Check if the response status is OK (status code 200-299)
      if (response.status >= 200 && response.status < 300) {
        setSnackbar({
          open: true,
          message: 'Thank you for subscribing!',
          severity: 'success'
        });
        setEmail(''); // Clear the input field
      }
    } catch (error) {
      // Handling error response from the server
      const errorMessage = error.response?.data?.message || 'Subscription failed';
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        pt: 10,
        bgcolor: '#f5f5f5'
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            py: 10,
          
            paddingRight: 4,
            bgcolor: 'transparent',
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h4"
              component="h4"
              gutterBottom
              sx={{
                fontWeight: 800,
                mb: 2,
                color: '#1a1a1a'
              }}
            >
              Coming Soon
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: '1rem', sm: '1.1rem'},
                color: '#666666',
                mb: 2
              }}
              paragraph
            >
              Our page is under construction.
            </Typography>
          </Box>

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              mt: 5,
              maxWidth: 400,
              mx: 'auto',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: 1,
              }}
            >
              <TextField
                fullWidth
                variant="standard"
                placeholder="Enter your email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                sx={{
                  '& .MuiInput-underline:before': {
                    borderBottomColor: 'rgba(0, 0, 0, 0.42)'
                  },
                  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottomColor: 'rgba(0, 0, 0, 0.87)'
                  },
                  '& .MuiInput-underline:after': {
                    borderBottomColor: '#06b6d4'
                  }
                }}
              />
              <Button
                type="submit"
                disabled={loading}
                sx={{
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                  minWidth: 'fit-content',
                  px: 2,
                  bgcolor: '#1385ca',
                  color: 'white',
                  '&:hover': {
                    bgcolor: '#0891b2'
                  },
                  '&:disabled': {
                    bgcolor: '#94a3b8'
                  }
                }}
              >
                {loading ? 'Saving...' : 'Notify me'}
              </Button>
            </Box>
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                mt: 2,
                textAlign: 'center',
                color: '#666666'
              }}
            >
              We'll notify you when we launch.
            </Typography>
          </Box>
        </Paper>
      </Container>

      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={6000} 
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleClose} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ComingSoonPage;